import vue from 'vue'
const that = vue.prototype
export default {
  className: 'authorizeAccount',
  fields: [
    'type',
    {
      name: 'user',
      note: '用户',
      tooltip: '请选择发帖用户',
      listWhere: (where) => {
        where.adminRole = {
          $exists: false
        }
      }
    }
  ],
  search: [
    'user',
    'type'
  ],
  hooks: {
    async beforeInsert ({ data, className }) {
      let id = typeof data.user === 'object' ? data.user.objectId : data.user
      let res = await that.$tkParse.getList(`/classes/${className}`,
        { params: { limit: 1, where: { user: id } } })
      if (res.length) {
        throw new Error('同一客户不能重复授权')
      }
    },
    async beforeUpdate ({ data, className, objectId }) {
      let id = typeof data.user === 'object' ? data.user.objectId : data.user
      let classData = await that.$tkParse.getData(`/classes/${className}/${objectId}`).catch(e => { return null })
      if (!classData) return
      if (id === classData.user) return
      let res = await that.$tkParse.getList(`/classes/${className}`,
        { params: { limit: 1, where: { user: id } } })
      if (res.length) {
        throw new Error('同一客户不能重复授权')
      }
    }
  }
}
